import { render } from "./Dental.vue?vue&type=template&id=35c75fa8"
import script from "./Dental.vue?vue&type=script&lang=ts"
export * from "./Dental.vue?vue&type=script&lang=ts"
script.render = render

export default script